var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "download_1_",
    "data-name": "download (1)",
    d: "M183.367,172.381l3.523-5.033a4.463,4.463,0,0,0-4.453-4.459H167.343a4.458,4.458,0,0,0-4.453,4.453l3.547,5.032a4.089,4.089,0,0,0-2.623,2.781h-.924v11.734h24V175.156H186a3.963,3.963,0,0,0-2.634-2.775Zm-4.119-4.2,1.645-1.645a.389.389,0,0,1,.55.55l-1.645,1.645a.389.389,0,1,1-.55-.551Zm-4.891-3.07a.4.4,0,0,1,.8,0v2.522a.4.4,0,0,1-.8,0Zm-6.019,1.425a.389.389,0,0,1,.55,0l1.645,1.645a.389.389,0,1,1-.55.55l-1.645-1.645A.39.39,0,0,1,168.337,166.54ZM166.9,173.35a1,1,0,0,0,.709-.675,2.745,2.745,0,0,1,2.73-2.145,2.87,2.87,0,0,1,1.576.469.788.788,0,0,0,.963-.1,2.883,2.883,0,0,1,4.37.4.792.792,0,0,0,.877.282,2.887,2.887,0,0,1,3.355,1.288.817.817,0,0,0,.7.4,2.893,2.893,0,0,1,2.708,1.893H164.939a2.986,2.986,0,0,1,1.956-1.806Zm8.794,7.139h-1.6v-3.2h1.6Z",
    transform: "translate(-162.89 -162.889)",
    fill: "#e7638e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDao);
export default __webpack_public_path__ + "static/media/dao.818575e0846074b800fa64d4993e9948.svg";
export { ForwardRef as ReactComponent };